import { TriangleDownIcon, XCircleFillIcon } from '@primer/octicons-react';
import { Box, Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { phuHuynhApi } from '../../api/phuHuynhApi';
import { useCommonContext } from '../../contexts/common';

interface IUserWithRole {
    id: number;
    username: string;
    full_name: string;
    phone_number: string;
    email: string;
    is_active: boolean;
    img: string;
    created_time: string;
    role_id: number;
    role_name: string;
}

type ComboboxNguoiPhuTrachProps = {
    isReadonly?: boolean;
    value?: number;
    onValueChanged: (id: number, data?: IUserWithRole) => void;
    className?: string;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
    isShowClearBtn?: boolean;
    maxWidth?: any;
};

const ComboboxNguoiPhuTrach = (props: ComboboxNguoiPhuTrachProps) => {
    const { translate } = useCommonContext();
    const [users, setUsers] = useState<IUserWithRole[]>([]);
    const [filter, setFilter] = useState('');
    const [open, setOpen] = useState(false);

	const fetchUsers = async () => {
		try {
			const response = await phuHuynhApi.GetUsersWithADMRoles();
			if (Array.isArray(response.data)) {
				setUsers(response.data);
			} 
			else if (Array.isArray(response.data?.data)) {
				setUsers(response.data.data);
			}
			else {
				console.error("Unexpected data structure:", response);
			}
		} catch (error) {
			console.error('Error fetching users:', error);
		}
	};

    useEffect(() => {
        fetchUsers();
    }, []);

    const dataSource = useMemo(() => {
        return users.map(x => ({
            id: x.id,
            text: `${x.full_name} - ${x.username}`,
            // ...
            data: x
        }));
    }, [users]);

    const filteredData = useMemo(() => {
        return dataSource.filter(item =>
            item.text.toLowerCase().includes(filter.toLowerCase())
        );
    }, [dataSource, filter]);

    const selectedData = useMemo(() => {
        return dataSource.find(item => item.id === props.value);
    }, [props.value, dataSource]);

    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button 
                    sx={{ maxWidth: 300 }}
                    trailingAction={TriangleDownIcon}
                    aria-labelledby={`${ariaLabelledBy}`}
                    {...anchorProps}
                >
                    <p style={{
                        maxWidth: props.maxWidth,
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }}>
                        {children || translate(`Chọn người phụ trách`)}
                    </p>
                </Button>
            )}
            title={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box sx={{ flex: 1 }}>
                        {translate(`Chọn người phụ trách`)}
                    </Box>
                    {props.isShowClearBtn && (props.value ?? 0) > 0 && (
                        <Button
                            trailingVisual={XCircleFillIcon}
                            variant='invisible'
                            sx={{ color: "danger.emphasis" }}
                            onClick={() => props.onValueChanged(0)}
                        >
                            Bỏ chọn
                        </Button>
                    )}
                </Box>
            }
            placeholderText="Tìm kiếm"
            open={open}
            onOpenChange={setOpen}
            items={filteredData}
            selected={selectedData}
            onSelectedChange={(data: any) => {
                const selectedUser = users.find(x => x.id === data.id);
                props.onValueChanged(data.id, selectedUser);
            }}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'large', height: 'medium' }}
        />
    );
};

export default ComboboxNguoiPhuTrach;